import { Channel, SalesChannels } from "@redotech/redo-model/sales-channels";
import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { SalesChannelState } from "@redotech/redo-return-ui/flows/return-flow/condition-types/sales-channel";
import { BadgeRedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { RedoTagsDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-tags-dropdown-input";
import { memo, useMemo } from "react";

export const SalesChannelDetails = memo(function SalesChannelDetails({
  state,
  setState,
  disabled,
}: ConditionTypeDetailsProps<SalesChannelState>) {
  const channelOptions: BadgeRedoListItem<string>[] = useMemo(
    () =>
      SalesChannels.map((channel: Channel) => ({
        id: channel.id,
        value: channel.id,
        type: "badge" as const,
        badge: { text: channel.displayName, color: "gray" as const },
      })),
    [],
  );

  const selectedOptions = useMemo(
    () => channelOptions.filter((option) => state.includes(option.value)),
    [channelOptions, state],
  );

  return (
    <RedoTagsDropdownInput
      disabled={disabled}
      label="Sales Channels"
      options={channelOptions}
      placeholder="Select sales channels..."
      selectedOptions={selectedOptions}
      setSelectedOptions={(items: BadgeRedoListItem<string>[]) => {
        setState(items.map((item) => item.value));
      }}
      size="xs"
    />
  );
});
